import { useMemo, useEffect } from "react";
import { getTripKey } from "../../utils/tripAnalysis";
import { useEscaletedLinesTodayStore } from '../../stores/hashs/useEscaletedLinesTodayStore';
import { useTripAlertsAnalysisStore } from '../../stores/analysis/useTripAlertsAnalysisStore';
import { useAlertN2Store } from "../../stores/hashs/useAlertN2Store";


export function useAlertsN2() {

    const trips = useEscaletedLinesTodayStore(
        state => state.data
    );

    const totalDay = useEscaletedLinesTodayStore(
        state => state.total
    );

    const alertsMap = useTripAlertsAnalysisStore(
        state => state.alertsMap
    );

    const setAlertN2 =
        useAlertN2Store(
            state => state.setAlertN2
        );

    const value = useMemo(() => {

        const data = [];

        for (const trip of trips) {

            const alerts = alertsMap.get(
                getTripKey(trip.DATA_REFERENCIA, trip.CODIGO_INTEGRACAO)
            );

            if (!alerts?.n2) {
                continue;
            }

            data.push(trip);

        }

        const total = data.length;

        return {
            data,
            total,
            totalDay,
            percentTotal:
                totalDay
                    ? Math.round(total / totalDay * 100)
                    : 0
        };

    }, [
        trips,
        alertsMap,
        totalDay
    ]);


    useEffect(() => {

        setAlertN2(value);

    }, [
        value,
        setAlertN2
    ]);

}